<template>
  <div class="animated fadeIn mt-3 dashboard">
    <b-card no-body class="objective-cards">

      <!-- ================= HEADER / FILTERS ================= -->
      <b-card-header>
        Objectivos
      </b-card-header>

      <b-card-body>

        <b-row class="mb-2">
          <b-col cols="12" sm="2" md="auto" class="px-1 mb-1">
            <b-form-select v-model="zone" :options="objectivesZones" size="sm" />
          </b-col>

          <b-col cols="12" sm="2" md="auto" class="px-1 mb-1">
            <b-form-select v-model="selectedDSR" :options="dsrOptions" value-field="value" text-field="text"
              size="sm" />
          </b-col>

          <b-col cols="12" sm="2" md="auto" class="px-1 mb-1">
            <b-form-select v-model="selectedRoutine" :options="routineOptions" size="sm" />
          </b-col>

          <b-col cols="12" sm="2" md="auto" class="px-1 mb-1">
            <b-form-select v-model="selectedPeriod" :options="objectivesPeriods" size="sm" />
          </b-col>

          <b-col cols="12" sm="2" v-if="selectedPeriod === 1">
            <input
              type="month"
              class="form-control form-control-sm"
              v-model="selectedDSRMonth"
            />
          </b-col>

          <!-- START MONTH (Acumulado) -->
          <b-col cols="12" sm="2" v-if="selectedPeriod === 2">
            <input
              type="month"
              class="form-control form-control-sm"
              v-model="accStartMonth"
            />
          </b-col>

          <!-- END MONTH (Acumulado) -->
          <b-col cols="12" sm="2" v-if="selectedPeriod === 2">
            <input
              type="month"
              class="form-control form-control-sm"
              v-model="accEndMonth"
            />
          </b-col>

          <b-col cols="12" sm="4">
            <b-button @click="applyFilters" variant="primary">
              Aplicar filtros
            </b-button>
          </b-col>
        </b-row>
        <b-row>

          <!-- Liters / DSR -->
          <b-col lg="5">
            <b-card>
              <template #header>
                <div class="font-weight-bold text-center">
                  Litros / DSR
                </div>
              </template>

              <b-overlay :show="dsrLoading.liters" rounded opacity="0.6" spinner-variant="primary">
                <b-table small bordered striped responsive :items="dsrObjectives.liters" :fields="dsrFields" :tbody-tr-class="rowClass"
                  show-empty />
              </b-overlay>
            </b-card>
          </b-col>

          <!-- GSV / DSR -->
          <b-col lg="4">
            <b-card>
              <template #header>
                <div class="font-weight-bold text-center">
                  GSV / DSR
                </div>
              </template>

              <b-overlay :show="dsrLoading.gsv" rounded opacity="0.6" spinner-variant="primary">
                <b-table small bordered striped responsive :items="dsrObjectives.gsv" :fields="dsrFields" :tbody-tr-class="rowClass" 
                show-empty />
              </b-overlay>
            </b-card>
          </b-col>

          <!-- Operators ≥ 6 / DSR -->
          <b-col lg="3">
            <b-card>
              <template #header>
                <div class="font-weight-bold text-center">
                  LEs ≥ 6 / DSR
                </div>
              </template>

              <b-overlay :show="dsrLoading.operators6" rounded opacity="0.6" spinner-variant="primary">
                <b-table small bordered striped responsive :items="dsrObjectives.operators6" :fields="dsrFields" :tbody-tr-class="rowClass"
                  show-empty />
              </b-overlay>
            </b-card>
          </b-col>

        </b-row>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'targets',

  data() {
    return {
      isInitializing: true,
      zone: null,
      selectedPeriod: 1,
      selectedMonth: null,
      selectedDSR: null,
      selectedRoutine: null,
      accStartMonth: null,
      accEndMonth: null,
      objectivesZones: [],
      objectivesPeriods: [
        { value: 1, text: 'Por mês' },
        { value: 2, text: 'Acumulado' }
      ],
      monthOptions: [],
      dsrOptions: [],
      routineOptions: [],

      mpgObjectives: {
        liters: [],
        gsv: [],
        operators6: []
      },

      objectiveFieldsWithQT: [
        { key: 'name', label: 'Gama' },
        { key: 'objective_value', label: 'Objectivo' },
        { key: 'current', label: 'Realizado' },
        { key: 'progress', label: 'Progresso' },
        { key: 'remaining', label: 'QT' }
      ],

      objectiveFieldsWithBalance: [
        { key: 'name', label: 'Gama' },
        { key: 'objective_value', label: 'Objectivo' },
        { key: 'current', label: 'Realizado' },
        { key: 'progress', label: 'Progresso' },
        { key: 'balance', label: 'Saldo' }
      ],

      dsrFields: [
        { key: 'name', label: 'Gama' },
        { key: 'objective_value', label: 'Objectivo' },
        { key: 'current', label: 'Realizado' },
        { key: 'progress', label: 'Progresso', formatter: v => `${v}%` },
        { key: 'quantity', label: 'QT' }
      ],

      dsrObjectives: {
        liters: [],
        gsv: [],
        operators6: []
      },
      selectedDSRMonth: null,
      dsrDateStart: null,
      dsrDateEnd: null,
      allRoutineOptions: [],
      routinesByDsr: {},
      dsrLoading: {
        liters: false,
        gsv: false,
        operators6: false
      }
    }
  },

  watch: {
    zone() {
      if (!this.zone || this.isInitializing) return
      // Reset filters
      this.selectedDSR = null
      this.selectedRoutine = null

      // Reload DSR & routines based on zone
      this.loadDSRAndRoutines()

      // Reload dashboard objectives
      // this.loadDashboardObjectives()
    },
    selectedPeriod() {
      if (this.selectedPeriod === 1) {
        this.accStartMonth = null
        this.accEndMonth = null
      }

      if (this.selectedPeriod === 2) {
        this.selectedDSRMonth = null
      }
    },

    accStartMonth() {
      this.updateAccumulatedDates()
    },

    accEndMonth() {
      this.updateAccumulatedDates()
    },
    // selectedMonth(val) {
    //   if (!val) return
    //   this.loadDashboardObjectives()
    // },
    selectedDSRMonth(val) {
      if (!val) {
        this.dsrDateStart = null
        this.dsrDateEnd = null
        return
      }

      const [year, month] = val.split('-').map(Number)

      // First day of month
      const start = new Date(year, month - 1, 1)

      // Last day of month
      const end = new Date(year, month, 0)

      this.dsrDateStart = this.formatDateLocal(start)
      this.dsrDateEnd = this.formatDateLocal(end)

      // Optional: auto-refresh
      // this.loadDSRTargets()
    },

    // keep the rest as-is
    selectedDSR(val) {
      if (!val) {
        this.routineOptions = this.allRoutineOptions
        this.selectedRoutine = null
        return
      }
      const routines = this.routinesByDsr[val] || []
      this.routineOptions = [
        { value: null, text: 'Todas' },
        ...[...routines].map(r => ({ value: r, text: r }))
      ]

      this.selectedRoutine = null
      // this.loadDSRTargets()
    }
  },

  methods: {
    applyFilters() {
      // this.loadDSRAndRoutines()
      this.loadDashboardObjectives()
      this.loadDSRTargets()
    },
    formatDateLocal(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    sumTargetsByMpgCode(targets) {
      const map = {}

      targets.forEach(t => {
        if (!t.mpg_code) return

        if (!map[t.mpg_code]) {
          map[t.mpg_code] = {
            ...t,
            objective_value: Number(t.objective_value || 0)
          }
        } else {
          map[t.mpg_code].objective_value += Number(t.objective_value || 0)
        }
      })

      return Object.values(map)
    },

    updateAccumulatedDates() {
      if (!this.accStartMonth || !this.accEndMonth) return

      const [startYear] = this.accStartMonth.split('-').map(Number)
      const [endYear, endMonth] = this.accEndMonth.split('-').map(Number)

      let startDate, endDate

      if (this.selectedPeriod === 2) {
        // For operators6, always Jan 1 of the start year
        startDate = new Date(startYear, 0, 1)
        // For other types, startDate = new Date(startYear, startMonth - 1, 1)
        endDate = new Date(endYear, endMonth, 0)
      }

      this.dsrDateStart = this.formatDateLocal(startDate)
      this.dsrDateEnd = this.formatDateLocal(endDate)
    },

    rowClass(item) {
      if (!item || item.progress == null) return ''

      return item.progress >= 100
        ? 'table-success'
        : 'table-danger'
    },

    loadDashboardObjectives() {
      if (!this.selectedMonth || !this.zone) return
      ['liters', 'gsv', 'operators6'].forEach(type => {
        this.loadObjectives(type, this.selectedPeriod, this.selectedMonth, this.zone)
      })
    },

    loadObjectives(type, period, dts, zone) {
      const data = {
        analysisType: period,
        rows: 'products',
        subrows: 'mpg_id',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: { day: dts.start, month: dts.month },
          end: { day: dts.end, month: dts.month }
        },
        zone
      }

      if (period === 2) {
        data.dates.start = { day: 1, month: 1 }
      }

      this.axios
        .post(`dashboard/mpg_objectives/${type}/${dts.year_month}`, data)
        .then(res => {
          this.mpgObjectives[type] = res.data.data
        })
    },

    /* ===================== DSR ===================== */

    async loadDSRAndRoutines() {
      if (!this.zone) return

      const { ini, fin } = this.getCurrentMonthRange()

      this.routinesByDsr = {}
      this.dsrOptions = []
      this.routineOptions = []

      const zoneParam =
        this.zone === 'ccss'
          ? 'ccss-objective'
          : this.zone

      const types = ['liters', 'gsv', 'operators6']

      const requests = types.map(type =>
        this.axios.get('objectives/getRealRotines', {
          params: {
            type,
            year_month_ini: ini,
            year_month_fin: fin,
            zone: zoneParam
          }
        })
      )

      const responses = await Promise.all(requests)

      const dsrMap = new Map()
      const routineSet = new Set()

      responses.forEach(res => {
        res.data.forEach(r => {
          // DSR list (zone filtered automatically by backend)
          if (r.salesteam_id && !dsrMap.has(r.salesteam_id)) {
            dsrMap.set(r.salesteam_id, {
              value: r.salesteam_id,
              text: r.salesteam_name
            })
          }

          // Routine list
          if (r.routine_code) {
            routineSet.add(r.routine_code)

            if (!this.routinesByDsr[r.salesteam_id]) {
              this.routinesByDsr[r.salesteam_id] = new Set()
            }

            this.routinesByDsr[r.salesteam_id].add(r.routine_code)
          }
        })
      })

      // DSR dropdown
      this.dsrOptions = [
        { value: null, text: 'Todos' },
        ...Array.from(dsrMap.values())
      ]

      // Routine dropdown
      this.allRoutineOptions = [
        { value: null, text: 'Todas' },
        ...Array.from(routineSet).map(r => ({
          value: r,
          text: r
        }))
      ]

      this.routineOptions = this.allRoutineOptions
    },
    generateMonthPeriods(startMonth, endMonth) {
      const periods = []

      const [startYear, startM] = startMonth.split('-').map(Number)
      const [endYear, endM] = endMonth.split('-').map(Number)

      let year = startYear
      let month = startM

      while (year < endYear || (year === endYear && month <= endM)) {
        const firstDay = new Date(year, month - 1, 1)
        const lastDay = new Date(year, month, 0)

        periods.push({
          ini: this.formatDateLocal(firstDay),
          fin: this.formatDateLocal(lastDay)
        })

        month++

        if (month > 12) {
          month = 1
          year++
        }
      }

      return periods
    },

    buildAccumulatedTable(type, currentReal, pastReal, targets) {
      const groupByMonth = (data) => {
        const map = {}
        data.forEach(r => {
          if (!map[r.year_month]) map[r.year_month] = []
          map[r.year_month].push(r)
        })
        return map
      }

      const currentByMonth = groupByMonth(currentReal)

      // ✅ SHIFT PAST YEAR → align 2025 → 2026
      const pastByMonthShifted = {}
      pastReal.forEach(r => {
        const shiftedMonth = r.year_month + 100 // 202501 → 202601

        if (!pastByMonthShifted[shiftedMonth]) {
          pastByMonthShifted[shiftedMonth] = []
        }

        pastByMonthShifted[shiftedMonth].push({
          ...r,
          year_month: shiftedMonth
        })
      })

      // ✅ deduplicate targets per month + mpg_code
      const targetsByMonth = {}
      targets.forEach(t => {
        if (!targetsByMonth[t.year_month]) {
          targetsByMonth[t.year_month] = {}
        }
        targetsByMonth[t.year_month][t.mpg_code] = t
      })

      const aggregated = {}

      Object.keys(targetsByMonth).forEach(month => {
        const currentMap = this.sumByMpgCode(currentByMonth[month] || [])
        const pastMap = this.sumByMpgCode(pastByMonthShifted[month] || [])

        const perBoxMap =
          type === 'liters'
            ? this.sumPerBoxByMpgCode(currentByMonth[month] || [])
            : {}

        Object.values(targetsByMonth[month]).forEach(t => {
          const code = t.mpg_code

          if (!aggregated[code]) {
            aggregated[code] = {
              name: t.mpg_name || code,
              current: 0,
              objective_value: 0,
              quantity: 0
            }
          }

          const current = currentMap[code] || 0
          const past = pastMap[code] || 0

          // ✅ CORRECT OBJECTIVE (NOW MATCHES MONTH)
          const objective = past + (past * (t.target || 0) / 100)

          aggregated[code].current += current
          aggregated[code].objective_value += objective

          // QT
          if (type === 'liters') {
            const perBox = perBoxMap[code] || 0

            if (current <= objective && perBox) {
              aggregated[code].quantity +=
                -1 * ((objective - current) / perBox)
            }
          }

          if (type === 'operators6') {
            aggregated[code].quantity += (current - objective)
          }
        })
      })

      return Object.values(aggregated).map(row => {
        const current = Number(row.current.toFixed(0))
        const objective = Number(row.objective_value.toFixed(0))

        const progress =
          objective === 0
            ? 0
            : Number(((current / objective) * 100).toFixed(1))

        return {
          name: row.name,
          current,
          objective_value: objective,
          progress,
          quantity: type === 'gsv'
            ? null
            : Number(row.quantity.toFixed(0))
        }
      })
    },

    async loadDSRTargets() {
      if (!this.zone) return

      let period = null

      if (this.selectedPeriod === 1) {
        if (!this.selectedDSRMonth) return

        period = {
          ini: this.dsrDateStart,
          fin: this.dsrDateEnd
        }
      }

      if (this.selectedPeriod === 2) {
        if (!this.accStartMonth || !this.accEndMonth) return

        if (this.accStartMonth > this.accEndMonth) {
          alert('Mês de início tem de ser inferior ao mês final')
          return
        }

        period = {
          ini: this.dsrDateStart,
          fin: this.dsrDateEnd
        }
      }

      const types = ['liters', 'gsv', 'operators6']

      for (const type of types) {
        this.dsrObjectives[type] = []
        this.dsrLoading[type] = true

        try {
          const hasFilter = !!this.selectedDSR || !!this.selectedRoutine

          let currentReal = []
          let pastReal = []
          let targets = []

          // ✅ NEW — ACUMULADO WITH FILTER (SIMPLIFIED)
          if (this.selectedPeriod === 2 && type !== 'operators6' && hasFilter) {
            currentReal = await this.fetchRealized(type, period)

            const pastPeriod = {
              ini: this.shiftYear(period.ini, -1),
              fin: this.shiftYear(period.fin, -1)
            }

            pastReal = await this.fetchRealized(type, pastPeriod)

            targets = await this.fetchTargets(type, period)

            this.dsrObjectives[type] = this.buildAccumulatedTable(
              type,
              currentReal,
              pastReal,
              targets
            )

            continue
          }

          currentReal = await this.fetchRealized(type, period)

          const pastPeriod = {
            ini: this.shiftYear(period.ini, -1),
            fin: this.shiftYear(period.fin, -1)
          }

          pastReal = await this.fetchRealized(type, pastPeriod)

          targets = await this.fetchTargets(type, period)

          let finalTargets = targets

          if (this.selectedPeriod === 2 && type !== 'operators6') {
            finalTargets = this.sumTargetsByMpgCode(targets)
          }

          if (type === 'operators6' && this.selectedPeriod === 2) {
            const [endYear, endMonth] = this.accEndMonth.split('-').map(Number)
            const selectedYearMonth = endYear * 100 + endMonth
            finalTargets = targets.filter(r => r.year_month === selectedYearMonth)
          }

          this.dsrObjectives[type] = this.buildDsrTable(
            type,
            currentReal,
            pastReal,
            finalTargets
          )
        } catch (err) {
          console.error(`Error loading DSR targets for ${type}`, err)
          this.dsrObjectives[type] = []
        } finally {
          this.dsrLoading[type] = false
        }
      }
    },

    shiftYear(dateStr, diff) {
      const d = new Date(dateStr)
      d.setFullYear(d.getFullYear() + diff)
      return d.toISOString().slice(0, 10)
    },

    fetchRealized(type, period) {
      const params = {
        type,
        year_month_ini: period.ini,
        year_month_fin: period.fin
      }
      if (this.zone) {
        // if zone represents only CCSS or ALL
        if (this.zone === 'ccss') {
          params.zone = 'ccss-objective'
        } else {
          params.zone = this.zone
        }
      }

      if (this.selectedDSR) {
        params.salesteam_id = this.selectedDSR
      }

      if (this.selectedRoutine) {
        params.routine_code = this.selectedRoutine
      }

      return this.axios
        .get('objectives/getRealRotines', { params })
        .then(res => res.data)
    },

    fetchTargets(type, period) {
      const params = {
        type,
        zone: this.zone
      }

      // Default: use selected period
      params.year_month_ini = period.ini
      params.year_month_fin = period.fin

      // operators6 always from Jan 1 to selected month
      let selectedYearMonth = null
      if (type === 'operators6' && this.selectedPeriod === 1 && this.selectedDSRMonth) {
        const [year, month] = this.selectedDSRMonth.split('-').map(Number)
        const startOfYear = new Date(year, 0, 1) // Jan 1
        const endOfMonth = new Date(year, month, 0) // last day of selected month
        params.year_month_ini = startOfYear.toISOString().slice(0, 10)
        params.year_month_fin = endOfMonth.toISOString().slice(0, 10)

        // also store the final year_month for filtering
        selectedYearMonth = year * 100 + month
      }

      if (this.selectedDSR) {
        params.salesteam_id = this.selectedDSR
      }

      if (this.selectedRoutine) {
        params.routine_code = this.selectedRoutine
      }

      return this.axios
        .get('objectives/getTarget', { params })
        .then(res => {
          let data = res.data

          // For operators6, keep only rows matching selected month
          if (type === 'operators6' && selectedYearMonth) {
            data = data.filter(r => r.year_month === selectedYearMonth)
          }

          return data
        })
    },

    sumByMpgCode(data) {
      const map = {}
      data.forEach(r => {
        map[r.mpg_code] = (map[r.mpg_code] || 0) + Number(r.value || 0)
      })
      return map
    },

    sumPerBoxByMpgCode(data) {
      const map = {}

      data.forEach(r => {
        const liters = Number(r.value || 0)
        const perBox = Number(r.per_box || 0)

        if (!perBox) return

        const quantity = liters / perBox

        if (!map[r.mpg_code]) {
          map[r.mpg_code] = {
            liters: 0,
            quantity: 0
          }
        }

        map[r.mpg_code].liters += liters
        map[r.mpg_code].quantity += quantity
      })

      const result = {}

      Object.keys(map).forEach(code => {
        const row = map[code]

        result[code] =
          row.quantity === 0
            ? 0
            : row.liters / row.quantity
      })

      return result
    },

    buildDsrTable(type, currentReal, pastReal, targets) {
      const currentMap = this.sumByMpgCode(currentReal)
      const pastMap = this.sumByMpgCode(pastReal)

      const perBoxMap =
        type === 'liters'
          ? this.sumPerBoxByMpgCode(currentReal)
          : {}

      const hasFilter = !!this.selectedDSR || !!this.selectedRoutine

      return targets.map(t => {
        if (!t.mpg_name) return null

        if (!t.mpg_name) {
          console.warn('Missing mpg_name for target:', t)
        }

        if (!currentMap[t.mpg_code]) {
          console.warn('Missing current for mpg_code:', t.mpg_code)
        }

        console.log('Targets count:', targets.length)
        console.log('Unique mpg_codes:', Object.keys(this.sumByMpgCode(currentReal)).length)

        const current = Number((currentMap[t.mpg_code] || 0).toFixed(0))
        const past = pastMap[t.mpg_code] || 0

        // OBJECTIVE
        let objective = 0

        if (hasFilter) {
          objective = past + (past * (t.target || 0) / 100)
        } else {
          objective = Number(t.objective_value || 0)
        }

        objective = Number(objective.toFixed(0))

        const progress =
          objective === 0
            ? 0
            : Number(((current / objective) * 100).toFixed(1))

        let quantity = null

        // operators6 QT
        if (type === 'operators6') {
          quantity = Number(((current - objective)).toFixed(0))
        }

        // liters QT
        if (type === 'liters') {
          const perBox = perBoxMap[t.mpg_code] || 0

          if (current > objective) {
            quantity = 0
          } else if (perBox !== 0) {
            quantity = -1 * Number(
              ((objective - current) / perBox).toFixed(0)
            )
          } else {
            quantity = 0
          }
        }

        return {
          name: t.mpg_name,
          current,
          objective_value: objective,
          progress,
          quantity,
          perBox: perBoxMap[t.mpg_code] || 0
        }
      }).filter(Boolean)
    },

    getCurrentMonthRange() {
      const now = new Date()

      const start = new Date(now.getFullYear(), now.getMonth(), 1)
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)

      return {
        ini: this.formatDateLocal(start),
        fin: this.formatDateLocal(end)
      }
    }
  },

  created() {
    this.axios.get('dashboard/objectives').then(res => {
      this.monthOptions = res.data.data.months
      this.objectivesZones = res.data.data.zones

      this.zone =
        this.objectivesZones &&
          this.objectivesZones.length > 0
          ? this.objectivesZones[0].value
          : null

      this.selectedMonth =
        this.monthOptions &&
          this.monthOptions.length > 1
          ? this.monthOptions[1]
          : null

      // this.applyFilters()
      // this.loadDSRAndRoutines()

      this.isInitializing = false

      this.loadDashboardObjectives()
    })
  }
}
</script>



// WEBPACK FOOTER //
// targets.vue?40fc76df